import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";

const Tag = ({ label, backgroundColor, textColor }) => {
    const { userLanguage } = useContext(LanguageContext)
    return (
        <div className="tag" style={{ backgroundColor: backgroundColor || "#830775" }}>
            <font><font style={{ color: textColor || 'white' }}>{text(label, userLanguage)}</font></font>
        </div>
    )
}

export default Tag;